import { HeatmapTooltip } from './HeatmapTooltip';
import { StyledHeatmapMetrics } from './Styled';

export const HeatmapMetrics = ({
  augmentedLinkData,
  totalCount,
  templateHeight,
  templateWidth,
}) => {
  return (
    <StyledHeatmapMetrics templateHeight={templateHeight} templateWidth={templateWidth}>
      {augmentedLinkData.map((value) => {
        const { x, y } = value;
        const urlKey = `href${value.hrefIndex}`;
        let text;

        // If the link has extra data
        if (value.totalCount != null && value.totalCount > 0) {
          // If the link was clicked, we have data on it
          text = `${value.totalCount.toLocaleString()} (${(
            (value.totalCount / totalCount) * 100
          ).toFixed(1)}%)`;
        } else {
          text = '0 (0%)';
        }
        return <HeatmapTooltip x={x} y={y} key={urlKey} urlKey={urlKey} text={text} />;
      })}
    </StyledHeatmapMetrics>
  );
};
